export const VERSION ="Folcon Gen2 general purpose e-commerce"
export const BUILD_DATE ="06-08-2025"
export const PACKAGE_CODE ="A2.2025.08.06.02"
